import React from 'react';
import Type from 'prop-types';
import { observer } from 'mobx-react-lite';
import * as Yup from 'yup';
import { Avatar, Typography } from '@material-ui/core';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import { authStore } from 'stores';
import { PhoneInput } from 'components';
import { ru } from 'locale';
import { validatePhone } from 'utils/validators';
import useStyles from './GetCode.styles';

const GetCode = observer(props => {
  const { isSubmitting } = props;
  const classes = useStyles();

  return (
    <>
      <div className={classes.avatarWrapper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          {ru.signIn}
        </Typography>
      </div>
      <div className={classes.fieldWrapper}>
        <PhoneInput autoFocus autoComplete="off" required fullWidth disabled={isSubmitting} />
      </div>
    </>
  );
});

GetCode.propTypes = {
  isSubmitting: Type.bool,
};

GetCode.defaultProps = {
  isSubmitting: false,
};

GetCode.initialValues = {
  phone: '',
};

GetCode.submitHandler = formData => {
  return authStore.sendCode(formData);
};

GetCode.validationSchema = Yup.object().shape({
  phone: Yup.string()
    .required(ru.requiredField(ru.phone))
    .test({
      test: validatePhone,
      message: ru.invalidPhoneNumber,
    }),
});

GetCode.buttonLabel = ru.getCode;

export default GetCode;
